module.exports = __webpack_public_path__ + "static/media/R-330XLHD_CrossSection.e5809b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/frFR/R-330XLHD_CrossSection.png
// module id = 503
// module chunks = 0